module.exports = __webpack_public_path__ + "img/4-1.022d3cb4.svg";